import axios from "axios";
import config from "./config";
import _ from "lodash";
import Cookies from "js-cookie";
import MemberInfo from "../global/js/memberinfo";
import { CurrentEnvPrefix } from "config/urlprefix.js";
var MD5 = require("../../node_modules/md5.js/index.js");

let initKey = function() {
  let m = MemberInfo.getMemberInfo();
  let c = Cookies.get("key");
  if (!_.isEmpty(m) || !_.isEmpty(c)) {
    config.authparams.key = m.key || c;
  }
};

let initStoreId = function() {
  let id = _getStoreid();
  config.authparams.storeid = id;
};

let _saveStoreid = function(store_id) {
  localStorage.setItem("storeid", store_id);
};

let _getStoreid = function() {
  let id = config.authparams.storeid;
  if (!id) {
    id = localStorage.getItem("storeid");
  }
  return id;
};

//获取登录权限
initKey();
//获取app id
initStoreId();

class API {
  //获取已授权列表
  get(param) {
    let _params = {};
    config.data = {};
    _.map(config.authparams, function(value, key) {
      _params[key] = value;
    });

    config.params = _params;
    _.extend(config.params, param.param);
    config.params = this.signCodeRequest(config.params);
    return axios.get(param.api, config);
  }
  //添加授权
  post(param) {
    let _params = {};
    config.params = {};
    _.map(config.authparams, function(value, key) {
      _params[key] = value;
    });
		config.data = _params;
		if (param.headers) {
			config.headers = param.headers;
    }
    _.extend(config.data, param.param);
    config.data = this.signCodeRequest(config.data);
    return axios.post(param.api, {}, config);
  }

  uploadFile(param, fileName, type, callbackProgress, callbackResult) {
    let _params = {};
    //拼接参数begin
    //获取公共参数到_params中
    _.map(config.authparams, function(value, key) {
      _params[key] = value;
    });
    //将公共参数和页面参数合并到_params中
    _.extend(_params, param.param);
    delete _params[fileName];
    //生成签名
    _params = this.signCodeRequest(_params);
    //当type为真时表示上传文件，node.js服务器需要把参数拼接到url中
    var api = config.baseURL + param.api;
    if (type) {
      _.map(_params, function(value, key) {
        if (api.indexOf("?") < 0) {
          api += "?";
        }
        api += "&" + key + "=" + value;
      });
    }
    //将请求参数转为表单
    var _formData = new FormData();
    _formData.append(fileName, param.param[fileName]);
    _.map(_params, function(value, key) {
      _formData.append(key, value);
    });
    return axios({
      url: api,
      method: "post",
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: function(progressEvent) {
        //原生获取上传进度的事件
        if (progressEvent.lengthComputable) {
          //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
          var _progress =
            (((progressEvent.loaded / progressEvent.total) * 100) | 0) + "%";
          callbackProgress(_progress);
        }
      },
      data: _formData
    })
      .then(res => {
        // console.log('上传成功');
        callbackResult(res);
      })
      .catch(error => {
        // console.log('上传失败')
        callbackResult(error);
      });
  }

  //资源上传
  uploadResource(param, callbackProgress, callbackResult) {
    return axios({
      url: CurrentEnvPrefix.main + param.api, //BASE_URL + '/handler/material/upload',
      method: "post",
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: function(progressEvent) {
        //原生获取上传进度的事件
        if (progressEvent.lengthComputable) {
          //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
          var _progress =
            (((progressEvent.loaded / progressEvent.total) * 100) | 0) + "%";
          callbackProgress(_progress);
        }
      },
      data: param.formdata
    })
      .then(res => {
        // console.log('上传成功');
        callbackResult(res);
      })
      .catch(error => {
        // console.log('上传失败')
        callbackResult(error);
      });
  }
  reqSuccess(obj, msg) {
    obj.$message({
      message: msg,
      type: "success"
    });
  }
  reqFail(obj, msg) {
    obj.$message({
      message: msg,
      type: "success"
    });
  }

  setMKey(member) {
    config.authparams.key = member;
  }
  getMKey() {
    return config.authparams.key;
  }
  setStoreid(store_id) {
    config.authparams.storeid = store_id;
    _saveStoreid(store_id);
  }
  getStoreid() {
    let id = config.authparams.storeid;
    if (!id) {
      id = _getStoreid();
    }
    return id;
  }
  signCodeRequest(obj) {
    var newkeys = Object.keys(obj).sort();
    var newObj = {};
    var SignCode = "";
    newkeys.forEach(function(item, index) {
      if (item.indexOf(":") == -1 && item != "SignCodeKey") {
        var v = obj[item] == undefined ? "" : obj[item];
        newObj[item] = v;
        SignCode += v;
      }
    });
    SignCode += config.authparams.SignCodeKey;
    newObj["Sign"] = new MD5().update(SignCode).digest("hex");
    return newObj;
  }
}

export default API;



// WEBPACK FOOTER //
// ./src/api/API.js